export default function currency() {

    /**
     * Convertir importe a moneda
     * @param {float} value importe a formatear
     * @returns float 
     */
    function formatCurrency(value) {
        return new Intl.NumberFormat('es-ES', {
                style: 'currency' ,
                currency: 'EUR'
            }).format(parseFloat(value));
    }
 
    return {
        formatCurrency
    }    

}